import { IOutreachLinks } from '@interfaces/outreachLinks';
import {
  BotConfigReconfigDto,
  CreateProductDto,
  FindProductsDto,
  IsProductOnFreePlanResponse,
  MirrorMembersDto,
  Product,
  ProductToUpdate,
  ValidateBotTokenCredentials,
  ValidateBotTokenResponse,
  disableBotByTokenCredentials,
  disableBotByTokenResponse,
} from '@interfaces/product';
import { IVibCost } from '@interfaces/vibCost';
import { fetcher } from '@utils/fetcher';

const API_URL = '/api/products';

export const createProduct = async (dto: CreateProductDto): Promise<Product> =>
  fetcher(`${API_URL}/create`, {
    method: 'POST',
    body: dto,
  });

export const findProducts = async (dto: FindProductsDto): Promise<Product[]> =>
  fetcher(API_URL, {
    method: 'POST',
    body: dto,
  });

export const disableBotByToken = async (
  dto: disableBotByTokenCredentials,
): Promise<disableBotByTokenResponse> =>
  fetcher(`${API_URL}/disableBotByToken`, {
    method: 'POST',
    body: dto,
  });

export const validateBotToken = async (
  dto: ValidateBotTokenCredentials,
): Promise<ValidateBotTokenResponse> =>
  fetcher(`${API_URL}/validateBotToken`, {
    method: 'POST',
    body: dto,
  });

export const updateProduct = async (
  code: Product['code'],
  dto: Partial<ProductToUpdate>,
): Promise<Product> =>
  fetcher(`${API_URL}/${code}`, {
    method: 'PUT',
    body: dto,
  });

export const findProduct = async (code: Product['code']): Promise<Product> =>
  fetcher(`${API_URL}/${code}`);

export const getOutreachLinks = async (
  code: Product['code'],
): Promise<IOutreachLinks> => fetcher(`${API_URL}/${code}/outreachLinks`);

export const isProductOnFreePlan = async (
  code: Product['code'],
): Promise<IsProductOnFreePlanResponse> => {
  return await fetcher(`${API_URL}/${code}/isProductOnFreePlan`);
};

export const getVibCost = async (code: Product['code']): Promise<IVibCost> =>
  fetcher(`${API_URL}/${code}/vibCost`);

export const mirrorCommunityMembers = async (
  code: Product['code'],
  dto: MirrorMembersDto,
): Promise<IVibCost> =>
  fetcher(`${API_URL}/${code}/mirrorMembers`, {
    method: 'PATCH',
    body: dto,
  });

export const botConfigReconfig = async (
  code: Product['code'],
  dto: BotConfigReconfigDto,
): Promise<IVibCost> =>
  fetcher(`${API_URL}/${code}/reconfig`, {
    method: 'PATCH',
    body: dto,
  });
